<template>
  <div>
    <header>
      <div class="left">
        <h2>Organisations</h2>
        <p>Manage organisations</p>
      </div>

      <div class="right">
        <a class="main-action" @click="openNewModal()">New organisation</a>
      </div>
    </header>

    <table class="acada-table orgs">
      <colgroup>
        <col style="width: 250px" />
        <col style="width: 32%" />
        <col style="width: 17%" />
        <col style="width: 17%" />
        <col style="width: 17%" />
        <col style="width: 17%" />
      </colgroup>

      <tr>
        <th></th>
        <th>Name</th>
        <th>Created</th>
        <th>FY Month</th>
        <th>Prefix</th>
        <th>Currency</th>
      </tr>

      <tr v-for="org of orgs" :key="org.id" @click="openEditModal(org.id)">
        <td>
          <img :src="org.logoUrl" class="img" />
        </td>

        <td>{{ org.orgName }}</td>

        <td>{{ formatDate(org.createdAt) }}</td>

        <td>{{ org.fy_month }}</td>

        <td>{{ org.prefix }}</td>

        <td>{{ currencyCodeById(org.currencyId) }}</td>
      </tr>
    </table>

    <org-modal
      :showing="modalShowing"
      :mode="mode"
      :toggleModal="toggleModal"
      :onSave="saveOrganisation"
      :onDelete="deleteOrganisation"
      :orgId="orgId"
    />
  </div>
</template>

<script>
import OrgModal from '../components/OrgModal';
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
  name: 'Organisations',
  data() {
    return {
      modalShowing: false,
      mode: 'New',
      orgId: -1,
    };
  },
  computed: {
    ...mapGetters(['currencyCodeById']),
    orgs() {
      return this.$store.getters.all_orgs;
    },
  },
  methods: {
    getOrganisations() {
      this.$store.dispatch('getAllOrgs');
    },
    saveOrganisation(org, file, categories, savingsTypes, organizationIdps) {
      const method = org.id ? 'updateOrg' : 'createOrg';
      return this.$store.dispatch(method, {
        org,
        file,
        categories,
        savingsTypes,
        organizationIdps,
      });
    },
    deleteOrganisation(org, cats) {
      const organizations = org.id ? [org.id] : [];
      const categories = cats ? cats.map(c => c.id) : [];
      return this.$store.dispatch('deleteOrg', { organizations, categories });
    },
    toggleModal(showing) {
      if (!showing) {
        this.orgId = null;
      }
      this.modalShowing = showing;
    },
    openNewModal() {
      this.mode = 'New';
      this.orgId = -1;
      this.modalShowing = true;
    },
    openEditModal(id) {
      this.mode = 'Edit';
      this.orgId = id;
      this.modalShowing = true;
    },
    formatDate(date) {
      return moment(date).format('DD MMM YYYY');
    },
  },
  created() {
    this.getOrganisations();
  },
  components: {
    'org-modal': OrgModal,
  },
};
</script>
